module.exports = __webpack_public_path__ + "static/media/29ADMSPC34.f5fa393f.jpg";